import { render, staticRenderFns } from "./jsonDialog.vue?vue&type=template&id=2fdcc521&scoped=true"
import script from "./jsonDialog.vue?vue&type=script&lang=js"
export * from "./jsonDialog.vue?vue&type=script&lang=js"
import style0 from "./jsonDialog.vue?vue&type=style&index=0&id=2fdcc521&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdcc521",
  null
  
)

export default component.exports